import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useAgencyPaymentMethod from '@hooks/useAgencyPaymentMethod'

import { confirmDelete } from '@functions/entity'

import { AgencyPaymentMethodModel } from '@models/types'

const AgencyPaymentMethodListItem = (props: { AgencyPaymentMethod: AgencyPaymentMethodModel }) => {
  const { AgencyPaymentMethod } = props

  const {
    callbacks: {
      createOrEditAgencyPaymentMethod,
      deleteAgencyPaymentMethod: deleteFn,
    },
    displayFee,
    paymentMethod,
  } = useAgencyPaymentMethod(AgencyPaymentMethod)

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This will remove the payment method from this agency.',
      deleteString: 'Remove',
      entityName: 'Payment Method',
    },
  }

  return (
    <DashboardModuleListItem
      secondaryText={displayFee}
      title={paymentMethod.title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditAgencyPaymentMethod()}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyPaymentMethodListItem
